import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'smata-header-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './header-page.component.html',
  styleUrl: './header-page.component.scss',
})
export class SmataHeaderPageComponent {
  @Input() title: string = '';
}
